export default __webpack_public_path__ + "static/media/nuevaesperanza1.d4b93e82.jpeg";